import RelationshipMetadata from "../../RelationshipMetadata";

class AdminPositionAdminPositionEmployeeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminPositionAdminPositionEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminPosition";
        this.childEnterpriseComponent = "AdminPositionEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "PositionUSID";
    }
}

export default AdminPositionAdminPositionEmployeeRelationshipMetadata;